import { BidBadge } from "./BidBadge"
import { TbClockHour3 } from "react-icons/tb"

export function BidBadgeSold({
  children,
  targetTime,
  date,
  backgroundColor,
  ...props
}) {
  return (
    <BidBadge
      variant={"default"}
      {...props}
      style={{ backgroundColor, ...props.style }}
    >
      <span className="flex items-center">
        <TbClockHour3 className="inline w-[21px] h-[21px] me-1 text-white" />
        Sold On <span className="font-semibold ms-1">{date}</span>
      </span>
    </BidBadge>
  )
}
